import {
  IconName,
  KebabMenu,
  KebabMenuIconPosition,
  KebabMenuOption
} from '@focaldata/cin-ui-components'
import React, { useState } from 'react'
import { DisplayLogicDraft } from '../../../data/model/audienceQuestionLogic'
import { useProjectType } from '../../Project/Project.hooks'
import DialogScreenerDisplayLogic from './DialogScreenerDisplayLogic'
import { useScreenerDisplayLogic } from './screenerDisplayLogic.hooks'
import { hasDisplayLogic } from './screenerDisplayLogic.utils'

interface Props {
  questionId: string
}

// The item only ever adds: once a condition exists the summary row owns editing.
const DisplayLogicControl: React.FC<Props> = ({ questionId }: Props) => {
  const [open, setOpen] = useState(false)
  const { isFdChat } = useProjectType()
  const { label, isTargeting, hasQuotas, logic, draft, questions, save } =
    useScreenerDisplayLogic(questionId)

  // Never reachable in fdchat, whose cards had no footer; the header they do have must not switch it on.
  if (isFdChat) return null

  const isSet = hasDisplayLogic(logic)

  const onSave = (next: DisplayLogicDraft) => {
    setOpen(false)
    void save(next)
  }

  const options: KebabMenuOption[] = [
    {
      id: 0,
      // A disabled menu item shows no tooltip, so the reason has to be in the label.
      textItem: hasQuotas
        ? 'Display logic — turn quotas off to use'
        : 'Add display logic',
      iconName: IconName.Preview,
      disabled: hasQuotas || isSet,
      onClickItem: () => setOpen(true)
    }
  ]

  return (
    <>
      <KebabMenu
        iconPosition={KebabMenuIconPosition.Left}
        kebabMenuOptions={options}
        tooltipText="Configure this question"
      />

      {open && (
        <DialogScreenerDisplayLogic
          open={open}
          questionLabel={label}
          isTargeting={isTargeting}
          draft={draft}
          questions={questions}
          onSave={onSave}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  )
}

export default DisplayLogicControl
